module.exports = __webpack_public_path__ + "static/img/icon_pico@2x.2419b6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_pico@2x.png
// module id = gTKk
// module chunks = 0